import "lazysizes";
import Scrollbar from 'smooth-scrollbar';
import BezierEasing from "bezier-easing";

// SCROLL
// -- Init
var scaleratio = $(window).outerHeight() / 1000;

window.addEventListener("orientationchange", function () {
  this.location.reload()
}, false)



if ($(".scrollContent").length > 0) {


  if (!viewportIsMobile($("body").outerWidth())) {
    var vdamping = 0.1;
    let scrollbars = {};
    scrollbars['root'] = Scrollbar.init($(".scrollContent")[0], {
      alwaysShowTracks: true,
      damping: vdamping
    });
  }
  // else {

  //   $(document).on('scroll', function () {
  //     if ($(this).scrollTop() >= $('.section--2 .btn-chitiet').position().top) {
  //       $(".section--2__content").addClass("active");
  //     } else {
  //       $(".section--2__content").removeClass("active");
  //     }
  //   })

  // }

}

var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Desktop: function () {
    return navigator.userAgent.match(/Windows NT/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

if ($(".scrollArticle").length > 0 && !viewportIsMobile()) {
  for (var i = 0; i < $(".scrollArticle").length; i++) {
    scrollbars['article'] = Scrollbar.init($(".scrollArticle")[i], {
      alwaysShowTracks: true
    })
  }
}


// function viewportIsMobile(width) {
//   return (width < 1025);
// }
function viewportIsMobile() {
  if (window.innerHeight > window.innerWidth) {
    return true;
  } else {
    return false;
  }
  // return (width < 1025);
}
// import Swiper from 'Swiper';


jQuery(document).ready(function () {
  //StaticMain(); 
  var Ios = $("#urlDownloadIos").attr("rel");
  var Android = $("#urlDownloadAndroid").attr("rel");

  if (isMobile.iOS()) {
    $('.bt-caidat').attr('href', Ios);

  } else if (isMobile.Android()) {
    $('.bt-caidat').attr('href', Android);
  }

  if (isMobile.any()) {
    var urlParam = new URLSearchParams(window.location.search);
    if (urlParam.has('vong-quay-sinh-nhat')) {
      $('html, body').stop().animate({
        scrollTop: $('#iframePromo').offset().top
      }, 1000);
    }
  }
});

// if (viewportIsMobile($("body").outerWidth())) {

//   $('.posts__list').on('scroll', function () {

//     if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
//       alert('scroll')
//     }
//   })

// } else {
//   if (isMobile.any()) {
//     $('.posts__list').on('touchend', function () {
//       if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
//         alert('touchstart')
//       }
//     })
//   } else {
//     $('.posts__list').on('mousewheel', function (e) {
//       if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
//         alert('mousewheel')
//       }
//     })

//   }
// }


window.Scrollbar = Scrollbar;